'use client';

import dynamic from 'next/dynamic';
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { TypePageTechnology } from '@fm-nx/contentful-types';
import get from 'lodash.get';

const Nav = dynamic(() => import('../../components/nav'));
const PageIntroLevel2Display = dynamic(
    () => import('@fm-nx/ui').then((mod) => ({ default: mod.PageIntroLevel2Display })),
    {
        ssr: false,
    }
);
const BlockRenderer = dynamic(() => import('@fm-nx/ui').then((mod) => ({ default: mod.BlockRenderer })));

interface TechnologyDetailProps {
    page: TypePageTechnology<'WITHOUT_UNRESOLVABLE_LINKS'>;
    preview: boolean;
}

export default function TechnologyDetail({ page, preview }: TechnologyDetailProps) {
    const updatedPage = useContentfulLiveUpdates(page);
    const { sections = [] } = updatedPage.fields;

    const tocRaw = get(updatedPage?.fields, 'tableOfContents', []);
    const toc: any[] = Array.isArray(tocRaw) ? tocRaw.filter((item: any) => item?.label && item?.anchor) : [];

    return (
        <div>
            <Nav variant="dark" preview={preview} />
            <PageIntroLevel2Display
                overline="Partners & Platforms"
                title={updatedPage?.fields.title || ''}
                headerText={updatedPage?.fields.heroHeading || updatedPage?.fields.title || ''}
                headerParagraph={updatedPage?.fields.summary}
                tableOfContents={toc}
                button={{
                    sys: { id: `page-intro-text-${updatedPage?.sys.id}` },
                    __typename: 'Button',
                    buttonText: 'Start a Conversation',
                    linkPath: '#contact',
                }}
                backgroundColor="banana"
            />
            <BlockRenderer block={sections} />
        </div>
    );
}
